<template>
  <div class="card-wrapper" v-if="checkPermission(['chartView_tuition_invoice2'])">
    <div class="card-top">
      <div class="card-header">
        <div class="card-heading">
          <div class="card-icon">
            <i class="el-icon-s-marketing"></i>
          </div>
          <div>
            <p class="card-title">{{ currentChartTitle }}</p>
            <p class="card-subtitle">Thống kê theo tháng trong năm {{ year }}</p>
            <div class="header-tags">
              <span class="header-tag">{{ activeCategoryLabel }}</span>
              <span class="header-tag header-tag--soft">{{ activeKidStatusLabel }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-row">
        <div class="mode-switcher">
          <button
            type="button"
            class="mode-chip"
            :class="{ 'mode-chip--active': activeChartMode === 'all' }"
            @click="setChartMode('all')"
          >
            Tổng quan
          </button>
          <button
            type="button"
            class="mode-chip"
            :class="{ 'mode-chip--active': activeChartMode === 'computed' }"
            @click="setChartMode('computed')"
          >
            Đã hoàn thành
          </button>
          <button
            type="button"
            class="mode-chip"
            :class="{ 'mode-chip--active': activeChartMode === 'notComputed' }"
            @click="setChartMode('notComputed')"
          >
            Chưa hoàn thành
          </button>
        </div>

        <div class="filter-selects">
          <div class="filter-group">
            <span class="filter-label">Phạm vi</span>
            <el-select
              v-model="dataSearchChart.category"
              class="input-common filter-select"
              placeholder="Trạng thái phiếu thu"
              clearable
              @change="handleChangeChartOrder"
            >
              <el-option
                v-for="item in categories"
                :key="item.value"
                :value="item.value"
                :label="item.name"
              ></el-option>
            </el-select>
          </div>

          <div class="filter-group">
            <span class="filter-label">Trạng thái học sinh</span>
            <el-select
              v-model="kidStatusForStatistic"
              placeholder="Trạng thái"
              class="filter-select filter-select--small"
              clearable
              @change="handleChangeKidStatus"
            >
              <el-option
                v-for="(item, index) in listKidStatusForStatistic"
                :key="index"
                :value="item.key"
                :label="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="summary-row" v-if="summaryCards.length">
        <div
          v-for="summary in summaryCards"
          :key="summary.label"
          class="summary-card"
          :style="{ '--summary-accent': summary.color }"
        >
          <span class="summary-label">{{ summary.label }}</span>
          <strong class="summary-value">{{ summary.value }}</strong>
        </div>
      </div>
    </div>

    <div class="chart-shell">
      <div class="chart-content" v-if="isLoading">
        <div class="state-card state-card--loading">
          <i class="el-icon-loading state-icon"></i>
          <div>
            <p class="state-title">Đang tải dữ liệu biểu đồ</p>
            <span class="state-text">Hệ thống đang đồng bộ dữ liệu phiếu thu học phí theo tháng.</span>
          </div>
        </div>
      </div>

      <div class="chart-content" v-else-if="hasData">
        <div class="chartFees">
          <div class="chart-caption">
            <span class="chart-caption__dot"></span>
            <span>{{ chartCaption }}</span>
          </div>
          <ChartBar
            :checkLable="true"
            :chartData="currentChartConfig.chartData"
            :options="currentChartConfig.options"
            :height="400"
          ></ChartBar>
        </div>
      </div>

      <div class="chart-content chart-empty" v-else>
        <div class="state-card state-card--empty">
          <i class="el-icon-document-delete state-icon"></i>
          <div>
            <p class="state-title">Chưa có dữ liệu phiếu thu học phí</p>
            <span class="state-text">Thử đổi chế độ xem hoặc bộ lọc để hiển thị thêm thống kê.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import checkPermission from "@/utils/permission";
import moment from "moment";
import ChartBar from "@/views/chartStatistical/chart/ChartBar.vue";
import DashboardService from "@/services/DashboardService";

export default {
  components: { ChartBar },
  name: "TuitionBillSummaryChart",
  data() {
    return {
      dataConnection: {},
      loaded: false,
      isLoading: false,
      kidsStatus: "",
      dataListOrder1: [],
      dataListOrder2: [],
      dataListOrderComputed1: [],
      dataListOrderComputed2: [],
      dataListOrderComputed3: [],
      dataListOrderComputed4: [],
      dataListOrderNotComputed1: [],
      dataListOrderNotComputed2: [],
      dataSearch: {
        type: "date",
        dateList: [
          moment().subtract(29, "days").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ],
      },
      dataSearchChart: {
        category: "",
      },
      checkComputed: false,
      checkNotComputed: false,
      showChartOrder: true,
      showChartOrderComputed: false,
      showChartOrderNotComputed: false,
      categories: [
        {
          id: 1,
          value: "CLASS",
          name: "Tất cả lớp",
        },
        {
          id: 2,
          value: "GROUP",
          name: "Tất cả nhóm",
        },
      ],
      kidStatusForStatistic: "",
      listKidStatusForStatistic: [
        { key: "STUDYING", value: "Đang học" },
        { key: "STUDY_WAIT", value: "Chờ học" },
        { key: "RESERVE", value: "Bảo lưu" },
        { key: "LEAVE_SCHOOL", value: "Nghỉ học" },
        { key: "OUT_SCHOOL", value: "Ra trường" },
      ],
      dataConnectionOrder: {},
      dataConnectionOrderComputed: {},
      dataConnectionOrderNotComputed: {},
      year: moment().format("YYYY"),
    };
  },
  computed: {
    activeChartMode() {
      if (this.showChartOrderComputed) return "computed";
      if (this.showChartOrderNotComputed) return "notComputed";
      return "all";
    },
    currentChartTitle() {
      if (this.showChartOrderComputed) return "Phiếu thu học phí đã hoàn thành";
      if (this.showChartOrderNotComputed) return "Phiếu thu học phí chưa hoàn thành";
      return "Tổng hợp phiếu thu học phí";
    },
    activeCategoryLabel() {
      if (!this.dataSearchChart.category) {
        return "Toàn trường";
      }

      const selectedCategory = this.categories.find(
        (item) => item.value === this.dataSearchChart.category,
      );
      return selectedCategory ? selectedCategory.name : "Toàn trường";
    },
    activeKidStatusLabel() {
      if (!this.kidStatusForStatistic) {
        return "Tất cả trạng thái";
      }

      const selectedStatus = this.listKidStatusForStatistic.find(
        (item) => item.key === this.kidStatusForStatistic,
      );
      return selectedStatus ? selectedStatus.value : "Tất cả trạng thái";
    },
    currentChartConfig() {
      if (this.showChartOrderComputed) {
        return this.dataConnectionOrderComputed;
      }

      if (this.showChartOrderNotComputed) {
        return this.dataConnectionOrderNotComputed;
      }

      return this.dataConnectionOrder;
    },
    chartCaption() {
      if (this.showChartOrderComputed) {
        return "Các nhóm phiếu thu đã hoàn thành theo từng tháng";
      }

      if (this.showChartOrderNotComputed) {
        return "Các nhóm phiếu thu chưa hoàn thành theo từng tháng";
      }

      return "So sánh tổng số phiếu thu hoàn thành và chưa hoàn thành trong năm";
    },
    hasData() {
      if (this.showChartOrderComputed) {
        return this.dataListOrderComputed1.length > 0;
      }
      if (this.showChartOrderNotComputed) {
        return this.dataListOrderNotComputed1.length > 0;
      }
      return this.dataListOrder1.length > 0;
    },
    summaryCards() {
      if (this.showChartOrderComputed) {
        return [
          {
            label: "Đóng đủ thừa",
            value: this.getChartTotal(this.dataListOrderComputed1),
            color: "#4f8dfd",
          },
          {
            label: "Đóng đủ 100%",
            value: this.getChartTotal(this.dataListOrderComputed2),
            color: "#ff7a59",
          },
          {
            label: "Đóng thừa",
            value: this.getChartTotal(this.dataListOrderComputed3),
            color: "#28c76f",
          },
          {
            label: "Đóng đủ thiếu",
            value: this.getChartTotal(this.dataListOrderComputed4),
            color: "#8b5cf6",
          },
        ];
      }

      if (this.showChartOrderNotComputed) {
        return [
          {
            label: "Chưa đóng đủ",
            value: this.getChartTotal(this.dataListOrderNotComputed1),
            color: "#ff9f43",
          },
          {
            label: "Chưa đóng 100%",
            value: this.getChartTotal(this.dataListOrderNotComputed2),
            color: "#7c4dff",
          },
        ];
      }

      return [
        {
          label: "Đã hoàn thành",
          value: this.getChartTotal(this.dataListOrder1),
          color: "#4f8dfd",
        },
        {
          label: "Chưa hoàn thành",
          value: this.getChartTotal(this.dataListOrder2),
          color: "#ff7a59",
        },
      ];
    },
  },
  async mounted() {
    if (this.checkPermission(["chartView_tuition_invoice2"])) {
      await this.searchChartOrder(this.year, this.dataSearchChart.category);
    }
  },
  methods: {
    checkPermission,
    getChartTotal(list) {
      return list.reduce((total, item) => total + Number(item || 0), 0);
    },
    setChartMode(mode) {
      this.checkComputed = mode === "computed";
      this.checkNotComputed = mode === "notComputed";
      this.showChartOrder = mode === "all";
      this.showChartOrderComputed = mode === "computed";
      this.showChartOrderNotComputed = mode === "notComputed";
      this.searchChartOrder(this.year, this.dataSearchChart.category);
    },
    handleChangeChartOrder() {
      this.searchChartOrder(this.year, this.dataSearchChart.category);
    },
    handleChangeKidStatus() {
      this.handleChangeChartOrder();
    },
    createDataset(label, data, color, hoverColor) {
      return {
        label,
        data,
        backgroundColor: color,
        hoverBackgroundColor: hoverColor,
        borderWidth: 0,
        barPercentage: 0.8,
        categoryPercentage: 0.68,
      };
    },
    createBarOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 30,
            right: 12,
            left: 12,
            bottom: 8,
          },
        },
        title: {
          display: false,
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            boxWidth: 9,
            padding: 20,
            fontSize: 12,
            fontColor: "#516074",
          },
        },
        tooltips: {
          mode: "index",
          intersect: false,
          backgroundColor: "rgba(19, 31, 53, 0.92)",
          titleFontSize: 12,
          bodyFontSize: 12,
          xPadding: 12,
          yPadding: 12,
          displayColors: true,
        },
        hover: {
          mode: "index",
          intersect: false,
        },
        plugins: {
          datalabels: {
            color: "#1f2d3d",
            anchor: "end",
            align: "end",
            clamp: false,
            clip: false,
            offset: 6,
            padding: {
              top: 2,
              bottom: 0,
            },
            font: {
              weight: "700",
              size: 12,
            },
            formatter: (value) => {
              return value > 0 ? value : "";
            },
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
                drawBorder: false,
              },
              ticks: {
                fontColor: "#6b7a90",
                autoSkip: false,
                fontSize: 12,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              afterDataLimits(scale) {
                const maxValue = Number(scale.max || 0);
                scale.max = maxValue > 0 ? Math.ceil(maxValue * 1.15 + 1) : 5;
              },
              gridLines: {
                color: "rgba(142, 169, 204, 0.18)",
                zeroLineColor: "rgba(142, 169, 204, 0.24)",
                drawBorder: false,
              },
              ticks: {
                beginAtZero: true,
                fontColor: "#7d8ca1",
                fontSize: 12,
                padding: 10,
                precision: 0,
              },
            },
          ],
        },
      };
    },
    async searchChartOrder(year, category) {
      this.isLoading = true;
      try {
        const kidStatus = this.kidStatusForStatistic;
        const response = await DashboardService.getAllChartOrder(year, category, kidStatus);
        this.resetListChart();
        for (let i = 0; i < response.data.length; i++) {
          const e = response.data[i];
          this.dataListOrder1.push(e.complete);
          this.dataListOrder2.push(e.noComplete);
          this.dataListOrderComputed1.push(e.yesMoneyNextMonth);
          this.dataListOrderComputed2.push(e.yesMoneyPaymentFull);
          this.dataListOrderComputed3.push(e.yesPaymentOverallMoney);
          this.dataListOrderComputed4.push(e.noPaymentNextMonth);
          this.dataListOrderNotComputed1.push(e.noMoneyPaymentFull);
          this.dataListOrderNotComputed2.push(e.noMoneyPayment);
        }
        this.fillDataOrder();
        this.fillDataOrderComputed();
        this.fillDataOrderNotComputed();
      } catch (e) {
        this.$message({
          message: "Failed to get the data",
          type: "error",
        });
      } finally {
        this.isLoading = false;
      }
    },
    resetListChart() {
      this.dataListOrder1 = [];
      this.dataListOrder2 = [];
      this.dataListOrderComputed1 = [];
      this.dataListOrderComputed2 = [];
      this.dataListOrderComputed3 = [];
      this.dataListOrderComputed4 = [];
      this.dataListOrderNotComputed1 = [];
      this.dataListOrderNotComputed2 = [];
    },
    fillDataOrderComputed() {
       this.dataConnectionOrderComputed = {
         chartData: {
           labels: this.$funcData.getListMonth(),
           datasets: [
             this.createDataset("Đóng đủ thừa", this.dataListOrderComputed1, "#4f8dfd", "#3273e6"),
             this.createDataset("Đóng đủ 100%", this.dataListOrderComputed2, "#ff7a59", "#ef6340"),
             this.createDataset("Đóng thừa", this.dataListOrderComputed3, "#28c76f", "#12b65a"),
             this.createDataset("Đóng đủ thiếu", this.dataListOrderComputed4, "#8b5cf6", "#7347dc"),
           ],
         },
         options: this.createBarOptions(),
       };
     },
     fillDataOrderNotComputed() {
       this.dataConnectionOrderNotComputed = {
         chartData: {
           labels: this.$funcData.getListMonth(),
           datasets: [
             this.createDataset("Chưa đóng đủ", this.dataListOrderNotComputed1, "#ff9f43", "#f18b24"),
             this.createDataset("Chưa đóng 100%", this.dataListOrderNotComputed2, "#7c4dff", "#6736ec"),
           ],
         },
         options: this.createBarOptions(),
       };
     },
     fillDataOrder() {
       this.dataConnectionOrder = {
         chartData: {
           labels: this.$funcData.getListMonth(),
           datasets: [
             this.createDataset("Đã hoàn thành", this.dataListOrder1, "#4f8dfd", "#3273e6"),
             this.createDataset("Chưa hoàn thành", this.dataListOrder2, "#ff7a59", "#ef6340"),
           ],
         },
         options: this.createBarOptions(),
       };
     },
   },
};
</script>

<style lang="scss" scoped>
.card-top {
  display: flex;
  flex-direction: column;
}

.chartFees {
  margin-top: 6px;
  height: 100%;
}

.chart-shell {
  position: relative;
  flex: 1;
  min-height: 390px;
  padding: 18px;
  border-radius: 24px;
  background:
    radial-gradient(circle at top right, rgba(100, 152, 255, 0.12), transparent 34%),
    linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid rgba(118, 153, 214, 0.14);
}

.card-wrapper {
  background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
  border-radius: 24px;
  box-shadow: 0 18px 40px rgba(31, 45, 61, 0.08);
  padding: 20px;
  margin: 20px 0;
  transition: all 0.3s ease;
  height: 100%;
  min-height: 560px;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(122, 147, 184, 0.12);
  box-sizing: border-box;
}

.card-wrapper:hover {
  box-shadow: 0 22px 48px rgba(31, 45, 61, 0.12);
  transform: translateY(-4px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.card-heading {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.card-icon {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #ffffff;
  background: linear-gradient(135deg, #4f8dfd, #7c4dff);
  box-shadow: 0 14px 24px rgba(79, 141, 253, 0.28);
}

.card-title {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #22324d;
}

.card-subtitle {
  margin: 6px 0 0;
  font-size: 13px;
  color: #7f8da3;
}

.filter-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.mode-switcher {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.mode-chip {
  border: 1px solid rgba(118, 153, 214, 0.18);
  background: #ffffff;
  color: #5c6d86;
  border-radius: 999px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 8px 18px rgba(31, 45, 61, 0.06);
}

.mode-chip:hover {
  transform: translateY(-1px);
  border-color: rgba(79, 141, 253, 0.3);
}

.mode-chip--active {
  color: #ffffff;
  border-color: transparent;
  background: linear-gradient(135deg, #4f8dfd, #7c4dff);
  box-shadow: 0 12px 24px rgba(79, 141, 253, 0.26);
}

.filter-selects {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
}

.filter-group {
  min-width: 160px;
  padding: 14px 16px;
  border-radius: 18px;
  background: rgba(244, 248, 255, 0.95);
  border: 1px solid rgba(118, 153, 214, 0.14);
}

.filter-label {
  display: inline-block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #72829a;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-right: 10px;
}

.filter-select {
  width: 180px;
}

.filter-select--small {
  width: 140px;
}

.header-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.header-tag {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #31527f;
  background: rgba(79, 141, 253, 0.12);
}

.header-tag--soft {
  background: rgba(111, 137, 168, 0.12);
  color: #62738c;
}

.summary-row {
  display: grid;
  gap: 12px;
  margin-bottom: 18px;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
}

.summary-card {
  position: relative;
  padding: 16px 18px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid rgba(118, 153, 214, 0.14);
  box-shadow: 0 10px 24px rgba(31, 45, 61, 0.06);
  overflow: hidden;
}

.summary-card::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  background: var(--summary-accent);
}

.summary-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #7d8ca1;
  margin-bottom: 8px;
}

.summary-value {
  font-size: 26px;
  line-height: 1;
  color: #21314c;
}

.chart-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.chart-caption {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin-bottom: 14px;
  border-radius: 999px;
  background: rgba(79, 141, 253, 0.08);
  color: #4f6483;
  font-size: 13px;
  font-weight: 600;
}

.chart-caption__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4f8dfd;
  box-shadow: 0 0 0 4px rgba(79, 141, 253, 0.14);
}

.state-card {
  min-height: 230px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px;
  text-align: left;
}

.state-card--loading {
  background: linear-gradient(135deg, rgba(79, 141, 253, 0.08), rgba(124, 77, 255, 0.08));
}

.state-card--empty {
  background: linear-gradient(135deg, rgba(242, 247, 255, 0.9), rgba(248, 251, 255, 0.95));
}

.state-icon {
  font-size: 36px;
  color: #4f8dfd;
}

.state-title {
  margin: 0 0 6px;
  font-size: 17px;
  font-weight: 700;
  color: #26344c;
}

.state-text {
  font-size: 13px;
  color: #7d8ca1;
  line-height: 1.6;
}

@media (min-width: 992px) {
  .card-top {
    min-height: auto;
  }
}

@media (max-width: 1200px) {
  .card-wrapper {
    min-height: 500px;
    margin: 12px 0;
  }
}

@media (max-width: 768px) {
  .card-top {
    min-height: auto;
  }

  .filter-row,
  .card-header {
    flex-direction: column;
  }

  .filter-selects,
  .filter-group,
  .filter-select,
  .filter-select--small {
    width: 100%;
  }

  .chart-shell {
    padding: 14px;
  }

  .state-card {
    flex-direction: column;
    text-align: center;
  }
}
</style>
